import { InputsFinalize } from './../index';

import { useState } from "react";
import { useSelector } from "react-redux";
import useApiRequest from "../../../../utils/hooks/useApiRequest";

import useFacility from "../../../../utils/hooks/useFacility";
import { GET_CARD_DEFINITIONS, GET_PAYMENT_DEFINITIONS } from "../../../api/apiRoutes";
import { DepositDefinition } from "../../../models/DepositDefinition";
import { setSaveAccountIncomeData } from "../../../models/SaveAccountIncomeData";
import { errorMessageFromApi } from "../../../utils/apiErrorMessages";
import { State } from "../../../store";
import useNewsletterConfirmation from "../../NewsletterConfirmation/useNewsletterConfirmation";
import { sendCheckoutNewsletterInvite } from "../../NewsletterConfirmation/sendCheckoutNewsletterInvite";

export default function useECard() {
  const facilityIds = useFacility();
  const [type, setTypesDefinition] = useState<DepositDefinition[]>([]);
  const [paymentUrl, setPaymentUrl] = useState<string>("");
  const [paymentError, setPaymentError] = useState("");
  const { sendInvite } = useNewsletterConfirmation();
  const alreadySubscribed = useSelector((state: State) => state.auth.userData.allowMailing);

  const { get, post } = useApiRequest();

  const requestGetAssortGroups = async () => {
    const { result, isError } = await get(GET_CARD_DEFINITIONS(facilityIds));
    if (!isError) {
      setTypesDefinition(result);
    }
  };

  const requestPaymentDefinition = async (data: InputsFinalize, definition: number) => {
    setPaymentError("");
    const response = await post(GET_PAYMENT_DEFINITIONS, {
      Ids: definition,
      facilityIds,
      ...setSaveAccountIncomeData(data),
    });
    if (!response.isError) {
      await sendCheckoutNewsletterInvite({
        sendInvite,
        facilityIds,
        email: data.email,
        allowMailing: data.allowMailing,
        alreadySubscribed,
      });
      setPaymentUrl(response.result.PaymentURL);
      return;
    }
    setPaymentError(errorMessageFromApi(response));
  };

  return {
    paymentUrl,
    requestPaymentDefinition,
    requestGetAssortGroups,
    type,
    paymentError,
  };
}
